// Definición de defaults

export const defaultTipoDependencia: TipoDependenciaProps = {
    idTipoDependencia:  0,
    descripcion:        '',
    activo:             false,
}

// Creación de interfaces

export interface TipoDependenciaProps   {
    idTipoDependencia:  number;
    descripcion:        string;
    activo:             boolean;
}